import { type FetchUserMeAuthenticationMethodsParams, type UserAuthenticationMethod } from '@capsicum/common';

import { useUserAuthMethodsQuery } from '../data-access/queries/useUserAuthMethodsQuery';

/**
 * @params 	FetchUserMeAuthenticationMethodsParams
 * @returns user auth methods
 */
export const useUserAuthMethods = (params?: FetchUserMeAuthenticationMethodsParams) => {
	const { data, error, isLoading } = useUserAuthMethodsQuery(params);
	const response = data as Array<UserAuthenticationMethod>;

	// 2FA must be enabled to set auth method
	const hasAuthSet =
		response?.[0]?.status === 'enabled' && response?.[0]?.isEnabledFor2FA && response?.[0]?.authenticationMethod
			? response?.[0]?.authenticationMethod?.method === 'password'
			: false;

	return {
		error,
		hasAuthSet,
		isLoading
	};
};
